import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import RetailOfferList from '../../../components/AdminRetailOffer/List';
import UpdateRetailOfferModal from '../../../components/AdminRetailOffer/Update/UpdateRetailOffer';
import SearchMenuItemModal from '../../../components/AdminRetailOffer/SearchMenuItem/RetailOfferSearchItem';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

@inject(
    'loginStore',
    'retailOfferStore'
)
@observer
class RetailOfferPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.retailOfferStore.init();
    }

    componentWillUnmount() {
        this.props.retailOfferStore.setShowUpdateRetailOfferModal(false);
    }

    handleCancelUpdateRetailOfferModal = () => {
        this.props.retailOfferStore.setShowUpdateRetailOfferModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.retailOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            showUpdateRetailOfferModal,
            showSearchMenuItemModal,
            manageRetailOfferTitle
        } = this.props.retailOfferStore;
        const { t } = this.props;

        return (
            <MainContainer title={t("Shopping Offer")} menukey='retailoffers'>
                <Modal
                    title={t(manageRetailOfferTitle)}
                    visible={showUpdateRetailOfferModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateRetailOfferModal}
                    zIndex={1000}
                >
                    <UpdateRetailOfferModal />
                </Modal>

                <Modal
                    title={t("Search Shopping")}
                    visible={showSearchMenuItemModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelSearchMenuIteModal}
                    zIndex={2000}
                >
                    <SearchMenuItemModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: "auto" }}>
                            <RetailOfferList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(RetailOfferPage);